import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const disabledSiteConfig: SiteConfigFn<Record<string, never>> = () => ({
	shouldLoadSiteFeature: false,
	shouldLoadSiteConfig: false,
	siteConfig: null,
})

const name = 'onloadCompsBehaviors'

export const config = { site: disabledSiteConfig, reactNativeSite: disabledSiteConfig, name }
